import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';

export const useDelivery = (deliveryId?: number | string | null) => {
  const query = useQuery({
    queryKey: [QueryKeys.Delivery, deliveryId],
    queryFn: async () => (deliveryId ? await API.deliveries.getDelivery(deliveryId) : undefined),
    enabled: Boolean(deliveryId),
  });

  return {
    ...query,
    isLoading: query.isFetching, // the query is only enabled when deliveryId is defined so technically it's not loading
  };
};
